var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36615 38.0001C2.36615 18.3139 18.3138 2.36621 38 2.36621C57.6862 2.36621 73.6339 18.3139 73.6339 38.0001C73.6339 57.6863 57.6862 73.634 38 73.634C18.3138 73.634 2.36615 57.6863 2.36615 38.0001Z",
    stroke: "#F2BC00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7387 42.0104C64.9488 28.3488 55.6655 15.4822 42.0038 13.2722C28.3422 11.0621 15.4757 20.3455 13.2656 34.0071C11.0556 47.6687 20.3389 60.5353 34.0005 62.7453C47.6622 64.9554 60.5287 55.672 62.7387 42.0104Z",
    stroke: "#F2BC00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1756 38.0002C25.1756 30.9255 30.9253 25.1758 38 25.1758C45.0747 25.1758 50.8244 30.9255 50.8244 38.0002C50.8244 45.0749 45.0747 50.8246 38 50.8246C30.9253 50.8246 25.1756 45.0986 25.1756 38.0002Z",
    stroke: "#F2BC00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a45b73cad6fe0a173e61fb79ca66ad08.svg";
export { ForwardRef as ReactComponent };